module.exports = __webpack_public_path__ + "img/img_right.32c47e75.jpg";